<template>
  <div>
    <div>
      <div class="common-form">日期{{form.service_time_arr[0].ymd}}</div>
      <el-checkbox class="checkbox" border :indeterminate="isIndeterminate" v-model="checkAllOne" @change="handleCheckAllChange">全选</el-checkbox>
      <el-checkbox-group v-model="checkedsure" @change="handleCheckedCitiesChange">
        <el-checkbox :checked="item.active == '2'" class="checkbox" border v-for="item in form.service_time_arr[0].list" :key="item.id" :label="item.busyId">{{item.busyStartTime}}-{{item.busyEndTime}}</el-checkbox>
      </el-checkbox-group>
    </div>
    <div>
      <div class="common-form">日期{{form.service_time_arr[1].ymd}}</div>
      <el-checkbox class="checkbox" border :indeterminate="isIndeterminatetoday" v-model="checkAllTwo" @change="handleCheckAllChangetoday">全选</el-checkbox>
      <el-checkbox-group v-model="checkedsuretoday" @change="handleCheckedCitiesChangetoday">
        <el-checkbox :checked="item.active == '2'" class="checkbox" border v-for="item in form.service_time_arr[1].list" :key="item.id" :label="item.busyId">{{item.busyStartTime}}-{{item.busyEndTime}}</el-checkbox>
      </el-checkbox-group>
    </div>
    <div>
      <div class="common-form">日期{{form.service_time_arr[2].ymd}}</div>
      <el-checkbox class="checkbox" border :indeterminate="isIndeterminatethree" v-model="checkAllThree" @change="handleCheckAllChangethree">全选</el-checkbox>
      <el-checkbox-group v-model="checkedsurethree" @change="handleCheckedCitiesChangethree">
        <el-checkbox :checked="item.active == '2'" class="checkbox" border v-for="item in form.service_time_arr[2].list" :key="item.id" :label="item.busyId">{{item.busyStartTime}}-{{item.busyEndTime}}</el-checkbox>
      </el-checkbox-group>
    </div>
  </div>

</template>
<script>
export default {
  inject: ["form"],
  data() {
    return {
      checkAllOne: false,
      checkAllTwo: false,
      checkAllThree: false,
      checkedsure: [],
      checkedsuretoday: [],
      checkedsurethree: [],
      isIndeterminate: false,
      isIndeterminatetoday: false,
      isIndeterminatethree: false
    };
  },
  created() {
    // 写入服务时间默认值 和天数数组
    console.log(this.form.service_time_arr, "服务时间默认值")
    if(this.form.service_time_arr){
       this.form.serviceTime = [
      this.form.service_time_arr[0].ymd,
      this.form.service_time_arr[1].ymd,
      this.form.service_time_arr[2].ymd
    ];
    let arr = this.form.service_time_arr;
    for (let index = 0; index < arr.length; index++) {
      for (let jindex = 0; jindex < arr[index]["list"].length; jindex++) {
        if (arr[index]["list"][jindex].active == 2) {
          this.form.serviceTime_newarr.push(
            arr[index]["list"][jindex].busy_id
          );
        }
      }
    }
    }
   
  },
  methods: {
    // 第一组
    handleCheckAllChange(val) {
      this.checkAllOne = val;
      this.isIndeterminate = false;
      this.checkedsure = val
        ? this.form.service_time_arr[0].list.map(item => item.busyId)
        : [];
      this.updateFormArr();
    },
    //
    handleCheckedCitiesChange(val) {
      this.checkedsure = val;
      const checkedCount = val.length;
      this.checkAllOne =
        checkedCount === this.form.service_time_arr[0].list.length;
      // 全选按钮状态
      this.isIndeterminate =
        checkedCount > 0 &&
        checkedCount < this.form.service_time_arr[0].list.length;
      this.updateFormArr();
    },
    // 第二组
    handleCheckAllChangetoday(val) {
      this.isIndeterminatetoday = false;
      this.checkAllTwo = val;
      this.checkedsuretoday = val
        ? this.form.service_time_arr[1].list.map(item => item.busyId)
        : [];
      this.updateFormArr();
    },
    handleCheckedCitiesChangetoday(val) {
      this.checkedsuretoday = val;
      const checkedCount = val.length;
      this.checkAllTwo =
        checkedCount === this.form.service_time_arr[1].list.length;
      this.isIndeterminatetoday =
        checkedCount > 0 &&
        checkedCount < this.form.service_time_arr[1].list.length;
      this.updateFormArr();
    },
    // 第三组
    handleCheckAllChangethree(val) {
      this.isIndeterminatethree = false;
      this.checkAllThree = val;
      this.checkedsurethree = val
        ? this.form.service_time_arr[2].list.map(item => item.busyId)
        : [];
      this.updateFormArr();
    },
    handleCheckedCitiesChangethree(val) {
      this.checkedsurethree = val;
      const checkedCount = val.length;
      this.checkAllThree =
        checkedCount === this.form.service_time_arr[2].list.length;
      this.isIndeterminatethree =
        checkedCount > 0 &&
        checkedCount < this.form.service_time_arr[2].list.length;
      this.updateFormArr();
    },
    // 更新提交的数组
    updateFormArr() {
      this.form.serviceTime_newarr = [
        ...this.checkedsure,
        ...this.checkedsuretoday,
        ...this.checkedsurethree
      ];
      this.form.serviceTime = [
        this.form.service_time_arr[0].ymd,
        this.form.service_time_arr[1].ymd,
        this.form.service_time_arr[2].ymd
      ];
    }
  }
};
</script>
<style scoped>
.checkbox {
  background-color: #eee;
  margin: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/technician/technicianlist/part/timeservice.vue